import React from "react";
import Header from "../components/header.js";

const ComingSoon = () => {
  const heading = {
    textAlign: "center",
    opacity: "0.4",
    marginTop: "50vh",
  };
  return (
    <>
      <Header />
      <h2 style={heading}>Coming soon</h2>
    </>
  );
};

export default ComingSoon;
